'use strict'

const state = {
  // tab list for process
  tabsAvailable: [
      {name: 'questionnaire'},
      {name: 'answers'},
      {name: 'competences'},
      {name: 'comments'}
  ]
}

const getters = {
  tabsAvailable (state) {
    return state.tabsAvailable
  }
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
